var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-[#E5E5E5] min-h-screen relative"},[_c('router-view',{on:{"loading":_vm.LoadingScreen}}),_c('vue-element-loading',{attrs:{"active":_vm.isLoading,"is-full-screen":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }